import AddClientPermissions from "../components/AddClientPermissions";
import Breadcrumb from "../components/Breadcrumb";

const AddClientPermissionsPage = () => {
  return (
    <>
      {/* Breadcrumb */}
      <Breadcrumb title="Add Client Permissions" />

      {/*Add client permissions */}
      <AddClientPermissions />
    </>
  );
};

export default AddClientPermissionsPage;
